<script setup lang="ts">
/**
 * Bridge component: Vue 2 v-model (value/input) → Vue 3 XPhone (modelValue/update:modelValue)
 *
 * Required while using @vue/compat in MODE: 2.
 * Once compat is removed or MODE is set to 3 globally, delete this file
 * and map SwordPhoneWuk directly to XPhone in global-components.ts
 */
import { XPhone } from '@swordhealth/ui'

const props = defineProps<{
  value?: string
  error?: string
}>()

const emit = defineEmits<{
  (e: 'input', value: string): void
  (e: 'reset-form-feedback'): void
}>()

const handleUpdate = (newValue: string) => {
  if (props.error) {
    emit('reset-form-feedback')
  }

  emit('input', newValue)
}
</script>

<template>
  <x-phone
    v-bind="$attrs"
    :model-value="value"
    :validation-triggers="{ onBlur: true, onChange: true, onInput: true }"
    @update:model-value="handleUpdate"
  />
</template>
